export default class DomUtils {
  static getComputedStyle(element, pseudo){
    return function(cssProperty){
      if(typeof window.getComputedStyle == "function"){
        return window.getComputedStyle(element, pseudo)[cssProperty];
      }else{
        // It is available in old versions of Microsoft Internet Explorer (propietary alternative to getComputedStyle)
        return element.currentStyle[cssProperty];
      }
    };
  }

  static offsetParent(element){
    if(element.nodeName !== 'HTML' && this.getComputedStyle(element)('position') === 'static'){
      return this.offsetParent(element.offsetParent);
    }
    return element;
  }

  static getVisibleWidth(element, width) {
    var clip;

    if (width) {
      return parseFloat(width);
    }

    clip = this.getComputedStyle(element)('clip');
    if (clip !== 'auto' && clip !== 'inherit') {
      clip = clip.split(/(?:\(|\))/)[1].split(/(?:,| )/);
      if (clip.length === 4) {
        return (parseFloat(clip[1]) - parseFloat(clip[3]));
      }
    }
    return 0;
  }

  static getScrollOffset() {
    if (window.pageXOffset) {
      return {
        x: window.pageXOffset,
        y: window.pageYOffset
      };
    }
    return {
      x: document.documentElement.scrollLeft,
      y: document.documentElement.scrollTop
    };
  }

  /**
   * Get pointer position in element
   * Returns an object with x and y coordinates.
   * The base on the coordinates are the bottom left of the element.
   *
   * @function getPointerPosition
   * @param {Element} el Element on which to get the pointer position on
   * @param {Event} event Event object
   * @return {Object} This object will have x and y coordinates corresponding to the mouse position
   */
 static getPointerPosition(el, event) {
    let position = {};
    let box = this.findElPosition(el);
    let boxW = el.offsetWidth;
    let boxH = el.offsetHeight;

    let boxY = box.top;
    let boxX = box.left;
    let pageY = event.pageY;
    let pageX = event.pageX;

    if (event.changedTouches) {
      pageX = event.changedTouches[0].pageX;
      pageY = event.changedTouches[0].pageY;
    }

    position.y = Math.max(0, Math.min(1, ((boxY - pageY) + boxH) / boxH));
    position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));

    return position;
 }

 /**
  * Offset Left
  * getBoundingClientRect technique from
  * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
  *
  * @function findElPosition
  * @param {Element} el Element from which to get offset
  * @return {Object}
  */
 static findElPosition(el) {
   let box;

   if (el.getBoundingClientRect && el.parentNode) {
     box = el.getBoundingClientRect();
   }

   if (!box) {
     return {
       left: 0,
       top: 0
     };
   }

   const docEl = document.documentElement;
   const body = document.body;

   const clientLeft = docEl.clientLeft || body.clientLeft || 0;
   const scrollLeft = window.pageXOffset || body.scrollLeft;
   const left = box.left + scrollLeft - clientLeft;

   const clientTop = docEl.clientTop || body.clientTop || 0;
   const scrollTop = window.pageYOffset || body.scrollTop;
   const top = box.top + scrollTop - clientTop;

   // Android sometimes returns slightly off decimal values, so need to round
   return {
     left: Math.round(left),
     top: Math.round(top)
   };
 }

}
